// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { PowerUpSettings } from "./Settings";
import { SoundManager } from "./SoundManager";
export function Explosion(x, y, pushRadius, push, damageRadius, damage) {
    this.x = x;
    this.y = y;
    this.pushRadius = pushRadius;
    this.push = push;
    this.damageRadius = damageRadius;
    this.damage = damage;
    SoundManager.playEffect(SoundManager.MATERIAL_STATE.DESTROY, SoundManager.MaterialCollection.TNT);
}
export var explosionTypeBlackBird = new Explosion(0, 0, PowerUpSettings.tntSettings.pushRange, 1700, PowerUpSettings.tntSettings.damageRange, 1500);
export var explosionTypeTNT = new Explosion(0, 0, PowerUpSettings.tntSettings.pushRange, 1700, PowerUpSettings.tntSettings.damageRange, 1500);
export var explosionTypeEgg = new Explosion(0, 0, PowerUpSettings.tntSettings.pushRange, 1200, PowerUpSettings.tntSettings.damageRange, 1000);
